import { render, staticRenderFns } from "./Saturation.vue?vue&type=template&id=278c1171"
import script from "./Saturation.vue?vue&type=script&lang=js"
export * from "./Saturation.vue?vue&type=script&lang=js"
import style0 from "./Saturation.vue?vue&type=style&index=0&id=278c1171&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports